import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import { ReactComponent as OakSvg } from '../../../../assets/icons/oak.svg';

const TreePlanting = () => {
  return (
    <>
      <Col md={12} className="border-bottom pb-2">
        <Row className="mx-0">
          <Col xs={6} className="py-2 centered-column">
            <h6 className="text-600">Total Trees</h6>
            <OakSvg className="land-dev-icon-40 mb-1" />
            <h5 className="fw-normal text-500 mb-0">7</h5>
          </Col>
          <Col xs={6} className="py-2 centered-column">
            <h6 className="text-600">Tree Species</h6>
            <h5 className="fw-normal text-500 mb-2">Oak</h5>
            <h6 className="text-600">Planting Date</h6>
            <h5 className="fw-normal text-500 mb-0">01-05-2025</h5>
          </Col>
        </Row>
      </Col>
      <Col md={12} className="border-bottom py-2 centered-column height-22">
        <Row className="mx-0">
          <Col xs={6} className="py-2 centered-column">
            <h6 className="fw-normal text-600">Survial Rate</h6>
            <h5 className="text-500 mb-0">85%</h5>
          </Col>
          <Col xs={6} className="py-2 centered-column">
            <h6 className="fw-normal text-600">Avg. Tree Age</h6>
            <h5 className="text-500 mb-0">0 year</h5>
          </Col>
          <Col xs={6} className="py-2 centered-column">
            <h6 className="fw-normal text-600">Growth Rate</h6>
            <h5 className="text-500 mb-0">35 cm/year</h5>
          </Col>
          <Col xs={6} className="py-2 centered-column">
            <h6 className="fw-normal text-600">Land Type</h6>
            <h5 className="text-500 mb-0">Other</h5>
          </Col>
        </Row>
      </Col>
      <Col md={12} className="py-2">
        <Flex justifyContent="between" alignItems="center" className="py-2">
          <h6 className="text-600 mb-0">Planting Cost</h6>
          <h6 className="text-600 mb-0">$ 350</h6>
        </Flex>
        <Flex justifyContent="between" alignItems="center" className="mb-2">
          <h6 className="text-600 mb-0">Annunal Maintenance Cost</h6>
          <h6 className="text-600 mb-0">$ 140</h6>
        </Flex>
        <Flex justifyContent="between" alignItems="center" className="mb-2">
          <h6 className="text-600 mb-0">Carbon Sequested for 30 years</h6>
          <h6 className="text-600 mb-0">429 KG</h6>
        </Flex>
        <Flex justifyContent="between" alignItems="center">
          <h6 className="text-600 mb-0">Carbon Credit Revenue</h6>
          <h6 className="text-600 mb-0">$</h6>
        </Flex>
      </Col>
    </>
  );
};
export default TreePlanting;
